var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-tooltip',{staticClass:"vx-info-title",attrs:{"title":_vm.title,"text":_vm.descriptionLocal,"position":"right"}},[_c('h5',{staticClass:"line-height-inherit"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n        "),_c('vx-basic-icon',{staticClass:"mt-0",staticStyle:{"vertical-align":"super"},attrs:{"size":"4","icon":"icon-info"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }